<template lang="pug">
  div
    content-loader(:height="7", v-if="alert.loading")
    b-card.table-card(v-else-if="payouts && payouts.length > 0")
      p(v-if='payouts.length < 1') No payouts
      b-table(v-else="", hover, :items="payouts", :fields="fields", @row-clicked="openRow", sort-icon-left, sort-by="id", :sort-desc="true", responsive, borderless)
        template(v-slot:cell(compAmount)="row") {{ formatRands(row.item.amount) }}
        template(v-slot:cell(actions)='row')
          .text-right
            b-button-group
              b-dropdown.m-0(no-caret="", variant="light")
                template(v-slot:button-content="")
                  font-awesome-icon(icon="ellipsis-v")
                b-dropdown-item(@click='openRow(row.item)') Open
    nothing(v-else="") No orders available
</template>

<script>

import { ContentLoader } from 'vue-content-loader';
import router from '@/router';
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';

export default {
  name: 'Payout',
  components: {
    ContentLoader,
  },
  mixins: [standardMix],
  data() {
    return {
      payouts: [],
      currentPage: 1,
      fields: [
        { key: 'artist_name', label: 'Artist' },
        { key: 'order_line_count', label: 'Items' },
        { key: 'compAmount', label: 'Total' },
        // { key: 'actions', label: '' },
      ],
    };
  },
  computed: {
    totalRows() {
      return this.payouts.length;
    },
  },
  methods: {
    refreshData() {
      const d = new Date();
      this.lastUpdate = `${d.getUTCHours() + 2}:${d.getUTCMinutes()}:${d.getUTCSeconds()}`;
      this.getResource('races');
    },
    openRow(row) {
      router.push({ name: 'PayoutEligible', params: { payoutId: row.artist_id } });
    },
  },
  async created() {
    this.loading();
    this.payouts = await apiService.getPayoutsEligible();
    this.clear();
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/PayoutsEligible.vue